module.exports = __webpack_public_path__ + "img/_004.64c4cbed.png";